module.exports = __webpack_public_path__ + "img/avoidedcost.086d8797.svg";